import { z } from 'zod'

import type { ZodInfer } from '@mntn-dev/utility-types'

export const UbsPaymentIdSchema = z.string().brand('ubs-payment')
export type UbsPaymentId = ZodInfer<typeof UbsPaymentIdSchema>

export const UbsPaymentId = (value: string): UbsPaymentId =>
  UbsPaymentIdSchema.parse(value)
